import http from '@/plugins/axios/axios';

export default class FuncionarioService {

    salvar(requisicao) { 
        return http.post('/api/funcionario/salvar', requisicao);
    }

    alterar(requisicao) { 
        return http.post('/api/funcionario/alterar', requisicao);
    }

    buscar(requisicao) { 
        return http.post('/api/funcionario/buscar', requisicao);
    }

    trocarContrato(requisicao) {         
        return http.post('/api/funcionario/trocar-contrato', requisicao);
    }

    trocarExcluirContrato(requisicao) {         
        return http.post('/api/funcionario/trocar-excluir-contrato', requisicao);
    }

    alterarDataInicioContrato(requisicao) {         
        return http.post('/api/funcionario/alterar-data-inicio-contrato', requisicao);
    }

    trocarCargo(requisicao) {         
        return http.post('/api/funcionario-cargo', requisicao);
    }

    alterarDataAtivacao(requisicao) {         
        return http.post('/api/funcionario/alterar-data-ativacao', requisicao);
    } 

    listarAfastamentos(requisicao) { 
        return http.post('/api/funcionario/listar-afastamentos', requisicao);
    }

    listar(requisicao) { 
        return http.post('/api/funcionario/listar', requisicao);
    }

    exportarParaArquivoCSV(requisicao) { 
        return http.post('/api/funcionario/exportar-csv', requisicao, {responseType: 'blob'});
    }

    importarCSV(requisicao) { 
        return http.post('/api/funcionario-upload/processar', requisicao);
    }

    fnalizarImportarCSV(requisicao) { 
        return http.post('/api/funcionario-upload/salvar', requisicao);
    }

    alterarFotoPerfil(requisicao) { 
        return http.post('/api/funcionario/alterar-foto-perfil', requisicao);
    }

    excluirFotoPerfil(requisicao) { 
        return http.post('/api/funcionario/excluir-foto-perfil', requisicao);
    }

    buscarFotoPerfil(idFuncionario) { 
        return http.get('/api/funcionario/buscar-foto-perfil/'+idFuncionario+'?fdb=f');
    }
}